import { useSetMarketingInfoRequest } from '../data';
import { useEffect } from 'react';
import { apiStatuses, routesPaths } from '@selfserve/react-utils';
import { WizardSteps } from '../../../../react-feature-webinar-creator/src/lib/utils/webinar-steps-helper';

interface Props {
  subscriptionId: string;
  data: any;
}

export const Redirector = ({ subscriptionId, data }: Props) => {
  const { mutateAsync: handleUpdateRequest, data: updateData } =
    useSetMarketingInfoRequest(subscriptionId);

  useEffect(() => {
    handleUpdateRequest({
      userData: data,
    });
  }, [handleUpdateRequest]);

  useEffect(() => {
    if (updateData?.status && updateData?.status === apiStatuses.CREATED) {
      window.location.href = updateData.data?.url as string;
    }
  }, [updateData]);

  return null;
};
